import { KeyFilterPattern } from 'primeng/keyfilter';
import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoTextAreaConfig extends IEoFormControlConfig {
  type?: 'textArea';
  autoResize?: boolean;
  rows?: number;
  cols?: number;
  maxlength?: number;
  minlength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  resizable?: boolean;
  showClear?: boolean;
  inputStyleClass?: string;
  pKeyFilter?: RegExp | KeyFilterPattern | null;
}

export class EoTextAreaConfig extends EoFormControlConfig implements IEoTextAreaConfig {
  override type?: 'textArea';
  autoResize?: boolean;
  rows?: number;
  cols?: number;
  maxlength?: number;
  minlength?: number;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
  resizable?: boolean;
  showClear?: boolean;
  inputStyleClass?: string;
  pKeyFilter?: RegExp | KeyFilterPattern | null;

  constructor();
  constructor(obj: IEoTextAreaConfig);
  constructor(obj?: IEoTextAreaConfig) {
    super(obj as IEoFormControlConfig);
    this.type = 'textArea';
    this.autoResize = obj?.autoResize ?? false;
    this.rows = obj?.rows ?? 2;
    this.cols = obj?.cols ?? 20;
    this.maxlength = obj?.maxlength;
    this.minlength = obj?.minlength;
    this.placeholder = obj?.placeholder;
    this.readonly = obj?.readonly ?? false;
    this.disabled = obj?.disabled ?? false;
    this.resizable = obj?.resizable ?? true;
    this.showClear = obj?.showClear ?? false;
    this.inputStyleClass = obj?.inputStyleClass;
    this.pKeyFilter = obj?.pKeyFilter;
  }
}